import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyFallbackRoute: InvariantJiraRoute = {
	name: 'legacy-fallback',
	path: '/:any',
};
